import { css } from '@emotion/css';
import {NavWidgetContents} from 'Shared/frontend/nav/NavWidgetContents';
import { sanitise } from 'Shared/common/Sanitise';
import { Show } from 'solid-js';
import { StandardNavWithLogo as StandardNavWithLogoSchema } from 'Shared/frontend/nav/navSchema';
import { ImageDetails } from 'Shared/model/basic';
import { useUrls } from 'Shared/UrlProvider';
import { theme } from 'Shared/frontend/SettingsProvider';
import { ShowWrapElement } from 'Shared/frontend/ShowWrapElement';

export const stickyStyle = () => ({
	position: 'sticky',
	overflow: 'visible',
	top: 0,
	left: 0,
	right: 0,
//		zIndex: 11,
	zIndex: 10,
});


export function StandardNavWithLogo(P:{logo:ImageDetails})
{
	const desktop = () => theme().nav.desktop as StandardNavWithLogoSchema;
	const settings = () => desktop().settings;
	const logoSide = () => settings().logoPosition;

	//XXX sticky sub navs are layed over this - bodgy: requires subnav to be at least as tall
	const outerStyle = styles => css({
			width: '100%',
			display: 'flex',
			justifyContent: 'center',
		},
		settings().sticky ? stickyStyle() : {},
		settings().outer,
		styles.css
	);

	const innerStyle = () => css({
			...sanitise.button,
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
		},
		settings().inner
	);

	const aStyle = css(sanitise.a,{
		display: 'contents',
	});

	const logoUrl = () => {
		if (!P.logo?.hash) return '';
		return useUrls().createVenueImageUrl(P.logo.hash,P.logo,'Venue-logo','full');
	};


	return (
		<ShowWrapElement path={['nav','desktop']}>{ styles =>
			<Show when={!styles().hide}>
				<nav class={outerStyle(styles())} >
					<div class={innerStyle()}>
						<Show when={logoSide()=='left'}>
							<a class={aStyle} href='/'>
								<img class={css(settings().logo)} src={logoUrl()} />
							</a>
						</Show>

						<NavWidgetContents logo={P.logo} />

						<Show when={logoSide()=='right'}>
							<a class={aStyle} href='/'>
								<img class={css(settings().logo)} src={logoUrl()} />
							</a>
						</Show>
					</div>
				</nav>
			</Show>
		}</ShowWrapElement>
	);
}

